import { render, staticRenderFns } from "./Ready.vue?vue&type=template&id=4a0550d3"
import script from "./Ready.vue?vue&type=script&lang=js"
export * from "./Ready.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports